const noop = (i) => console.log("noop", i)

const ItemButtons = ({
    n,
    of,
    depth=1,
    onMoveUp=noop,
    onMoveDown=noop,
    allowChangeIndent=false,
    onMoveLeft=noop,
    onMoveRight=noop
}) => {

    return (
        <>
            <button
                disabled={n===0}
                onClick={() => onMoveUp(n)}
                className="swap-btn"
            >
                ^
            </button>
            <button
                disabled={n === of}
                onClick={() => onMoveDown(n)}
                className="swap-btn"
            >
                v
            </button>
            {allowChangeIndent &&
            <>
                <button
                    disabled={depth ===1 }
                    className="swap-btn"
                    onClick={() => onMoveLeft(n)}
                >
                    &lt;
                </button>
                <button
                    className="swap-btn"
                    onClick={() => onMoveRight(n)}
                >
                    &gt;
                </button>
            </>}
        </>
    )
}

export default ItemButtons